module.exports = __webpack_public_path__ + "img/pen-grey.6016366e.svg";